var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/privacy-notice.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/privacy-notice.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("helpUrl")) {
var t_4 = t_1.helpUrl;
} else {
cb(new Error("cannot import 'helpUrl'")); return;
}
context.setVariable("helpUrl", t_4);
output += "\n\n";
var t_5;
t_5 = (lineno = 2, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.ca-privacy-config",[]]));
frame.set("privacyConfig", t_5, true);
if(frame.topLevel) {
context.setVariable("privacyConfig", t_5);
}
if(frame.topLevel) {
context.addExport("privacyConfig", t_5);
}
output += "\n";
var t_6;
t_6 = (lineno = 3, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.privacyRestriction.userIsResident",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("userIsResident", t_6, true);
if(frame.topLevel) {
context.setVariable("userIsResident", t_6);
}
if(frame.topLevel) {
context.addExport("userIsResident", t_6);
}
output += "\n";
var t_7;
t_7 = (lineno = 4, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.privacyRestriction.userHasDismissedPrivacyNotice",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("noticeHasBeenDismissed", t_7, true);
if(frame.topLevel) {
context.setVariable("noticeHasBeenDismissed", t_7);
}
if(frame.topLevel) {
context.addExport("noticeHasBeenDismissed", t_7);
}
output += "\n\n<div class=\"dom-privacy-notice\">\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "userIsResident") && !runtime.contextOrFrameLookup(context, frame, "noticeHasBeenDismissed") && !(lineno = 8, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["renderCache.usingPwaHeaderFooter",runtime.contextOrFrameLookup(context, frame, "False")]))) {
output += "\n\n        <div class=\"c-cookies-alert\">\n\n            <div class=\"o-row\">\n\n                <div class=\"g-cookies-alert__inner c-cookies-alert__inner\">\n\n                    <div class=\"g-cookies-alert__disclaimer\">\n                        <p class=\"s-cms c-cookies-alert__p\">\n                            ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "privacyConfig")),"noticeCopy")), env.opts.autoescape);
output += "\n                        </p>\n                    </div>\n\n                    <div class=\"g-cookies-alert__button\">\n                        <button class=\"c-button-primary c-cookies-alert__button js-dismiss-privacy-notice\" type=\"button\">\n                            ";
output += runtime.suppressValue((lineno = 24, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cookies_alert_ok_button"])), env.opts.autoescape);
output += "\n                        </button>\n                    </div>\n\n                </div>\n\n            </div>\n\n        </div>\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/privacy-notice.j2"] , dependencies)